package com.devi3east.bashbuddy.dashboard.ui.components.inputFields

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import com.devi3east.bashbuddy.features.common.util.formatPrice
import kotlin.math.roundToLong

@Composable
fun CurrencyTextField(
    label: String,
    valueCents: Long,
    onValueChange: (Long) -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true
) {
    var isFocused by remember { mutableStateOf(false) }
    var text by remember { mutableStateOf(formatPrice(valueCents)) }

    LaunchedEffect(valueCents, isFocused) {
        if (!isFocused) text = formatPrice(valueCents)
    }

    OutlinedTextField(
        value = text,
        onValueChange = { newText ->
            if (!enabled) return@OutlinedTextField

            val filtered = newText.filter { it.isDigit() || it == '.' }
            text = filtered

            val decimalString = if (filtered.startsWith(".")) "0$filtered" else filtered
            val number = decimalString.toDoubleOrNull()

            if (number != null) {
                onValueChange((number * 100.0).roundToLong())
            } else if (filtered.isEmpty()) {
                onValueChange(0L)
            }
        },
        label = {
            Text(
                text = label,
                style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Medium)
            )
        },
        keyboardOptions = KeyboardOptions.Default.copy(
            keyboardType = KeyboardType.Number,
            imeAction = ImeAction.Done
        ),
        modifier = modifier.onFocusChanged { focusState ->
            if (!enabled) return@onFocusChanged

            val nowFocused = focusState.isFocused
            if (nowFocused && !isFocused) {
                text = if (text == formatPrice(valueCents)) "" else text.filter { it.isDigit() || it == '.' }
            }
            if (!nowFocused && isFocused) {
                val decimalString = if (text.startsWith(".")) "0$text" else text
                val number = decimalString.toDoubleOrNull()
                text = if (number != null) formatPrice((number * 100.0).roundToLong())
                else formatPrice(valueCents)
            }
            isFocused = nowFocused
        },
        singleLine = true,
        shape = RoundedCornerShape(12.dp),
        visualTransformation = VisualTransformation.None,
        textStyle = MaterialTheme.typography.bodyMedium,
        enabled = enabled
    )
}